import { Injectable } from '@angular/core';
import { HttpRequestService } from '../_common/http-request.service';

@Injectable()
export class LineUserService {

    RequestOptions: any = {};

    constructor(
        private http: HttpRequestService,
    ) { }

    upload(formData) {
        return this.http.post('lineuser/upload', formData)
            .map(res => {
                return res.json();
            });
      }

    gets(parameters) {
        return this.http.get('lineuser', parameters)
            .map(res => {
                return res.json();
            })
    }

    block(model: any) {
        return this.http.put(`lineuser/block`,
            model).map(res => {
                return res.json();
            });
    }

    adminBlock(model: any) {
        return this.http.put(`lineuser/adminBlock`,
            model).map(res => {
            return res.json();
        });
    }

    delete(id: number) {
        return this.http.delete(`lineuser/delete?id=${id}`)
            .map(res => {
                return res.json();
            });
    }

    add(model: any) {
        return this.http.post('lineuser/add',model)
            .map(res => {
                return res.json();
            });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/line-user.service.ts